import {Assistant} from '../../../app/components/Assistant';
import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectAssistantContents} from '../coreSlice';
import {useDemo} from '../../demo/hooks/useDemo';
export const PageAssistant = () => {
  const assistantContents = useAppSelector(selectAssistantContents);
  const activeAssistantContent = assistantContents[assistantContents.length - 1];
  const {isDemo} = useDemo();
  if (!isDemo) {
    return null;
  }
  return (
    <div className={'page-container px-4 pt-4 w-full sm:px-6 sm:pt-6 lg:px-16'}>
      {activeAssistantContent && <Assistant className={'w-full'} {...activeAssistantContent} />}
    </div>
  );
};
